'use client';

import { cartActions } from '@/fo/store/product';
import {
  UiLandingProductCardEsthederm,
  Product
} from '@/fo/ui/landing/product-card/esthederm';
import { staticMediaUrl } from '@/fo/util/image-loader';

import { styles } from './ProductSection.styles';

export interface ProductSectionProps {
  products: Product[];
}

export function ProductSection({ products }: ProductSectionProps) {
  const slots = styles();
  return (
    <div
      id="products"
      className={slots.base()}
    >
      {products.map((product, index) => {
        const rowType =
          index % 3 === 0 ? 'first' : index % 3 === 1 ? 'second' : 'third';
        return (
          <div
            key={product.name}
            className={slots.row({ rowType })}
          >
            <div className={slots.visual({ rowType })}>
              <div className={slots.imageWrap({ rowType })}>
                {product.label && (
                  <p className={slots.label({ rowType })}>{product.label}</p>
                )}
                {product.image?.sm && product.image.md && (
                  <picture>
                    <source
                      srcSet={product.image.sm}
                      media="(max-width: 767px)"
                    />
                    <img
                      className={slots.image({ rowType })}
                      src={product.image.md}
                      alt={product.name}
                    />
                  </picture>
                )}
                {product.refill && (
                  <div className={slots.refill({ rowType })}>
                    <img
                      className={slots.refillImage()}
                      src={product.refill.image}
                      alt="Intensive NAD+"
                    />
                    <div className={slots.refillContent()}>
                      <p className={slots.refillTitle()}>
                        {product.refill.title}
                      </p>
                      <p className={slots.refillValue()}>
                        {product.refill.value}
                        <span className={slots.refillValueSmall()}>%</span>
                      </p>
                      <p className={slots.refillText()}>
                        {product.refill.text}
                      </p>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className={slots.product({ rowType })}>
              <UiLandingProductCardEsthederm
                product={product}
                positionIndex={index}
                onAddToCart={() =>
                  cartActions.addProductsToCart([
                    {
                      sku: product.sku ?? '',
                      quantity: 1,
                      product: {
                        sku: product.sku ?? '',
                        name: product.name || '',
                        brand: '',
                        series: '',
                        volume: product.volume || '',
                        basePrice: product.basePrice || 0,
                        finalPrice: product.finalPrice || null,
                        baseImage: product.baseImage || { src: '', alt: '' }
                      }
                    }
                  ])
                }
              />
            </div>
          </div>
        );
      })}
      <picture>
        <source
          srcSet={staticMediaUrl('landing/ie_intensive_nad/bg-products.png')}
          media="(min-width: 768px)"
        />
        <img
          className={slots.bg()}
          src={staticMediaUrl('landing/ie_intensive_nad/products-bg-sm.png')}
          alt="Intensive NAD+"
        />
      </picture>
    </div>
  );
}
